// extracted by mini-css-extract-plugin
export default {"lang":"LanguageSelector_lang__Kd6e7","menu":"LanguageSelector_menu__sz3zv"};